export default "__VITE_ASSET__Cfvlqu6j__"